class Form {
    fields = []; //Field
    submit = {}; //Link

    constructor(submit, fields) {
        this.submit = submit;
        if (fields !== undefined) {
            this.fields = fields;
        } else {
            this.fields = [];
        }
    }
}

export default Form;